export default __webpack_public_path__ + "static/principles-of-use-do-light-222f587c7b722749b1f0dd1ca92c81a6e27d234026a56ea8c0375da18361a415.png";